/* eslint-disable import/no-cycle */
import api from './api.service';

function index(params) {
  return api.get('/teachers/', params);
}

function get(id, params) {
  return api.get(`/teachers/${id}`, params);
}

function create(params) {
  return api.post('/teachers', params);
}

function update(id, params) {
  return api.put(`/teachers/${id}/update`, params);
}

function updateCommonInfo(id, params) {
  return api.put(`/teachers/${id}/update-common-info`, params);
}

function remove(id, params) {
  return api.delete(`/teachers/${id}`, params);
}

function box(id, params) {
  return api.delete(`/teachers/${id}/box`, params);
}

function save(params) {
  return (params.id) ? update(params.id, params) : create(params);
}

function addCampaign(id, params) {
  return api.post(`/teachers/${id}/campaigns`, params);
}

function exportData(params) {
  return api.get('/teachers/export', params);
}

export const teachersService = {
  index,
  get,
  create,
  update,
  remove,
  save,
  addCampaign,
  exportData,
  updateCommonInfo,
  box,
};
